<div class="p-8">
    <p>
        {{dataLabel | translate | stringFormat:data.selectedList.length}}
    </p>
    <mat-checkbox (change)="downloadAttachments($event)" *ngIf="selectAttachments">
        <p style="font-size: 1.3rem">{{"DIALOGS.REPORTS.DOWNLOAD_ATTACHMENTS" | translate}}</p>
    </mat-checkbox>
    <div fxLayout="row wrap" style="justify-content: space-evenly">
        <button mat-raised-button color="primary" class="my-8" (click)="onContinue(false)">{{"ALERTS.MASSIVE_ACTIONS.CONTINUE" | translate}}</button>
        <button mat-raised-button color="secondary" class="my-8 px-8" (click)="onContinue(true)">{{ labelSelectAll | translate}} ({{data.allItems}})</button>
    <div>
</div>